//TODO: this seems like a really terrible name
$('body').on('click', '.enableControls', function (e) {
  var opts =
    $(this).data('enableControls') || $(this).metadata().enableControlsOpts;
  ht.toggleFormControls(opts.targetElement, {
    enable: true,
    selector: opts.targetSelector
  });
});
